<div
	[class.bg-primary-2]="entry.selected"
	class="flex flex-row items-center justify-start"
>
	<mat-list-item
		(click)="select.emit(entry)"
		class="cursor-pointer truncate"
		matRippleDisabled
	>
		<mat-radio-button
			(click)="$event.preventDefault()"
			[checked]="entry.selected"
			[labelPosition]="'after'"
			[name]="entry.id"
			class="mat-checkbox-flex mat-checkbox-radio w-full"
			color="primary"
			tabindex="0"
		>
			<span class="truncate"> {{ entry.name }}</span>
		</mat-radio-button>
	</mat-list-item>
	<ng-container
		*ngTemplateOutlet="customMenu ? customMenu : defaultMenu; context: { $implicit: entry }"
	></ng-container>
</div>
<ng-template #defaultMenu></ng-template>
